export const SwissParties: {[key in SwissParty]: {color: string, displayTitle: string}} = {
    'SP': {color:'#ff0000', displayTitle: 'SP'},
    'FDP': {color:'#3570b2', displayTitle: 'FDP'},
    'SVP': {color:'#4b8a3e', displayTitle: 'SVP'},
    'GPS': {color:'#83b547', displayTitle: 'GPS'},
    'GLP': {color:'#c4c43d', displayTitle: 'GLP'},
    'Mitte': {color:'#d6862b', displayTitle: 'Mitte'},
    'andere': {color:'lightgrey', displayTitle: 'andere'},
}